import React, { Component } from "react";
import { Card } from "react-bootstrap";
import "../Elements/FromGroup/form_select.css";
import AscModal from "../Elements/Modal/Modal";
import { ViewDeleteVocHistoryList } from "../Elements/AscElements/VocHistoryElements";

/**
 * VoC分析作成履歴 削除確認モーダル
 */
export default class VocHistoryDeleteModal extends Component {
  render() {
    return (
      <AscModal
        state={this.props.state}
        propSetState={this.props.propSetState}
        langText={this.props.langText}
        validationHandle={this.props.validationHandle}
        onClick={this.props.onClick}
      >
        <Card variant="info">
          <Card.Header>
            <Card.Title>
              {/* 対象一覧 */}
              {this.props.langText.Body.VocReport}
            </Card.Title>
          </Card.Header>
          <Card.Body>
            <ViewDeleteVocHistoryList state={this.props.state} langText={this.props.langText} />
          </Card.Body>
        </Card>
      </AscModal>
    );
  }
}


